import { Injectable } from '@angular/core';
import * as Sentry from '@sentry/angular';
@Injectable({
  providedIn: 'root'
})
export class SentryService {

  constructor() { }

  logError(error: any, context?: Record<string, any>) {
    if (context) {
      Sentry.setContext("error-context", context);
    }
    Sentry.captureException(error);
  }

  logMessage(message: string, level: Sentry.SeverityLevel = "info", context?: Record<string, any>) {
    if (context) {
      Sentry.setContext("message-context", context);
    }
    Sentry.captureMessage(message, level);
  }

  addBreadcrumb(breadcrumb: {
  category: string;
  message: string;
  level?: Sentry.SeverityLevel;
  data?: Record<string, any>; }) {
  Sentry.addBreadcrumb(breadcrumb);
  }

}
